<template>
  <v-app class="app">
      <v-carousel
        :continuous="false"
        :show-arrows="true"
        hide-delimiters
        class="carousel"
        :height="null"
        v-model="page_number"
      >
        <ib-slide
          v-for="(slide, i) in slides"
          :slide="slide"
          :index="i"
          :key="i"
        ></ib-slide>
      <div
      v-intersect="isIntersecting">
      </div>
      </v-carousel>
    <div class = "page-counter">{{page_number + 1}}/{{slides.length}}</div> 
  </v-app>
</template>

<script>

import ibSlide from "@/components/slide.vue"
import english from "@/english.json"
import spanish from "@/spanish.json"

let lang = english

export default {
  name: 'App',
  components: {ibSlide},
  data: () => ({
    page_number: 0,
    slides: lang, //imported from json above
    pageHeight: 0,
    isIntersecting: true
  }),
  computed: {
    landscape() {
      return this.$vuetify.breakpoint.height >= this.$vuetify.breakpoint.width
    },

  },
  methods: {
    onIntersect (isIntersecting, entries, observer) {
        this.isIntersecting = isIntersecting
      },
  },
  beforeCreate() {
    let params = new URLSearchParams(document.location.search)
    if (params.get("lang") === "spanish"){ //get query to choose json language
      lang = spanish
    } else {
      lang = english
    }
  }
};
</script>

<style>

  html {
    /* overflow: hidden; */
  }

  body {
    /* overflow: hidden; */
    height: 100%;
    width: 100%;
  }

  .carousel {
    width: 100%;
    height: 100%;
  }

  @media all and (orientation:landscape) {
    .slide-body {
      flex-direction: row;
    }
    .slide-img {
      max-height: 100%; 
    }
  }
 
  @media screen and (min-width: 800px) {
    body {
      background-color: grey;
      display: flex;
      justify-content: center;
    }
    .v-application--wrap {
      max-width: 768px;
      max-height: 384px;
      min-height: auto !important;
      overflow: hidden;
    }    
    .app {
      max-width: 768px;
      max-height: 384px;
      background-color: white;
      align-self: center;
      box-shadow: 8px 8px 16px #555;
    }    
    .carousel {
      background-color: white;
      height: 100%;
      width: 100%;
      max-width: 768px;
      max-height: 384px;
      height: 384px !important;
      min-height: auto !important;
      min-width: auto !important;
    }
    .carousel-item {
      width: 768px;
      height: 384px;   
    }

    .v-window__container {
      width: 768px !important;
      height: 384px !important;   
    }
  }

  .page-counter {
    position: fixed;
    bottom: 10px;
    font-weight: bold;
    opacity: 0.5;
    font-size: 1.5em;
    right: 20px;
    z-index: 1000;
    pointer-events: none;
  }

</style>